import React, { useEffect, useState } from 'react';
import ReactImageGallery from 'react-image-gallery';
import { FaTimesCircle } from 'react-icons/fa';

const ScoreboardPhotos = (props) => {
  const [fQuestion, setFQuestion] = useState(null);

  //Format question to proper format. Has to be in a useEffect to work
  useEffect(() => {
    
    const qid = props.question.question.path;
    props.firebase
      .path(qid)
      .get()
      .then((result) => {
        const question = {
          ...result.data(),
          id: result.id,
        };
        setFQuestion(question);
      })
      .catch((err) => {
        if (err.code === 'permission-denied') {
        } else {
        }
      });
  }, [props.firebase, props.question.question.path]);

const isMediaQuestion = (type) => type === 'camera' || type === 'video' || type === 'audio';

const getAnswer = (user, question) => {
  if (!user.answers) {
    if (isMediaQuestion(question.type)) {
      return FaTimesCircle;
    } else {
      return 'Ikke svart';
    }
  }
  const ans = user.answers.find((a) => a.questionId === question.id);

  if (ans) {
    if (ans.answer instanceof Array) {
      return ans.answer.join(", ");
    } else {
      return ans.answer;
    }
  }
  return isMediaQuestion(question.type) ? FaTimesCircle : 'Ikke svart';
};

const getAnswerUrl = (user, question) => {
  if (!user.answers) {
    return null;
  }
  const ans = user.answers.find((a) => a.questionId === question.id);

  if (ans) {
    if (ans.answer instanceof Array) {
      return ans.answer.join(", ");
    } else {
      return ans.answer;
    }
  } else {
    return null;
  }
};

  const formatResponses = (question, users) => {
    const mediaList = [];

    if (question.type === 'camera') {
      users.forEach((u) => {
        const url = getAnswerUrl(u, question);

        if (url) {
          mediaList.push({
            original: url,
            description: u.teamName,
            thumbnail: url,
            originalWidth: 680,
          });
        }
      });

      return (
        <div
          style={{
            borderBottom: '1px solid #DDD',
            marginBottom: '3rem',
            padding: '4rem',
          }}
        >
          <p style={{ fontSize: '1.4rem' }}>
            {fQuestion && fQuestion.question}
          </p>

          {mediaList.length ? (
            <>
              <ReactImageGallery items={mediaList} />
              <div style={{ marginTop: '1rem' }}>
                {mediaList.map((item, idx) => (
                  <div key={idx} style={{ marginBottom: '0.5rem' }}>
                    <a href={item.original} target="_blank" rel="noreferrer">
                      Åpne bilde i ny fane ({item.description})
                    </a>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className="d">Ingen medier lastet opp enda.</div>
          )}
        </div>
      );
    }

    if (question.type === 'video') {
      users.forEach((u) => {
        const url = getAnswerUrl(u, question);

        if (url) {
          mediaList.push({ url, teamName: u.teamName });
        }
      });

      return (
        <div
          style={{
            borderBottom: '1px solid #DDD',
            marginBottom: '3rem',
            padding: '4rem',
          }}
        >
          <p style={{ fontSize: '1.4rem' }}>
            {fQuestion && fQuestion.question}
          </p>

          {mediaList.length ? (
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                gap: '1.5rem',
              }}
            >
              {mediaList.map((item, idx) => (
                <div key={idx}>
                  <a href={item.url} target="_blank" rel="noreferrer">
                    <video
                      src={item.url}
                      controls
                      preload="metadata"
                      playsInline
                      style={{
                        width: '100%',
                        maxWidth: '720px',
                        aspectRatio: '16 / 9',
                        backgroundColor: '#000',
                        borderRadius: '0.5rem',
                      }}
                    />
                  </a>
                  <div style={{ marginTop: '0.5rem' }}>{item.teamName}</div>
                </div>
              ))}
            </div>
          ) : (
            <div className="d">Ingen medier lastet opp enda.</div>
          )}
        </div>
      );
    }

    if (question.type === 'audio') {
      users.forEach((u) => {
        const url = getAnswerUrl(u, question);

        if (url) {
          mediaList.push({ url, teamName: u.teamName });
        }
      });

      return (
        <div
          style={{
            borderBottom: '1px solid #DDD',
            marginBottom: '3rem',
            padding: '4rem',
          }}
        >
          <p style={{ fontSize: '1.4rem' }}>
            {fQuestion && fQuestion.question}
          </p>

          {mediaList.length ? (
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
                gap: '1.2rem',
              }}
            >
              {mediaList.map((item, idx) => (
                <div key={idx}>
                  <a href={item.url} target="_blank" rel="noreferrer">
                    <audio
                      src={item.url}
                      controls
                      style={{ width: '100%' }}
                    />
                  </a>
                  <div style={{ marginTop: '0.5rem' }}>{item.teamName}</div>
                </div>
              ))}
            </div>
          ) : (
            <div className="d">Ingen medier lastet opp enda.</div>
          )}
        </div>
      );
    }

    return null;
  };

  if (fQuestion && isMediaQuestion(fQuestion?.type))
    return (
      <div>{fQuestion && formatResponses(fQuestion, props.users)}</div>
    );
  return (<></>);
};

export default ScoreboardPhotos;
